import React from 'react';

import { Chip, ChipTypography } from './styled';
import { ChipProps } from '../types';

const CardChip = ({ label, className, type }: ChipProps): JSX.Element => (
    <Chip data-testid="chip" className={className} type={type}>
        <ChipTypography>{label}</ChipTypography>
    </Chip>
);

export default CardChip;
